<template>
  <div class="tupu">
    <div style="width: 100%; height: 100%;display: flex; flex-direction: row;flex: 1" v-if="isPhone == false">
      <div id="mynetwork"></div>
      <div class="searchClass">
        <el-button type="primary" style="" @click="goRollback()" size="small">
          <i class="iconfont icon-huitui"/>回退
        </el-button>
        <el-input placeholder="请输入关键词，回车搜索" v-model="searchKey" @change="searchclick"></el-input>

<!--        <el-button type="primary" icon="el-icon-document-copy" @click="() => { dialogVisible = true }"-->
<!--                   size="medium">图谱检索</el-button>-->
      </div>
    </div>
    <div style="width: 100%" class="phonr_item" v-if="isPhone == true">
      <!-- v-model="activeName" -->
      <el-tabs type="card" class="demo-tabs">
        <!-- @tab-click="handleClick" -->
        <el-tab-pane label="树型图" name="first">
          <div id="ecologicalTree" style="width: 100vw; height: 100%"></div>
        </el-tab-pane>
        <el-tab-pane label="图片" name="second">
          <div>

            <div id="mynetwork"></div>
            <!-- @click="goDe()" -->
            <el-button style="position: absolute; top: 100px; right: 10px" type="primary" icon="el-icon-document-copy"
                       @click="() => { dialogVisible = true }" size="medium">图谱检索</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-drawer title="节点信息" :visible.sync="dialogTableVisiblejd" direction="rtl" :modal="false">
      <div class="detail">
        <div class="detail_item">
          <div class="detail_item_title">节点</div>
          <div class="detail_item_value">
            {{ chooseData.name ? chooseData.name : chooseData.label }}
          </div>
        </div>
        <div v-if="chooseData.Authors" class="detail_item">
          <div class="detail_item_title">作者</div>
          <div class="detail_item_value">{{ chooseData.Authors }}</div>
        </div>
        <div v-if="chooseData.Keywords" class="detail_item">
          <div class="detail_item_title">关键字</div>
          <div class="detail_item_value">{{ chooseData.Keywords }}</div>
        </div>
        <div v-if="chooseData.Abstract" class="detail_item">
          <div class="detail_item_title">摘要</div>
          <div class="detail_item_value">{{ chooseData.Abstract }}</div>
        </div>
        <div v-if="chooseData.area" class="detail_item">
          <div class="detail_item_title">活动范围</div>
          <div class="detail_item_value">{{ chooseData.area }}</div>
        </div>
        <div class="detail_item" v-if="chooseData.description">
          <div class="detail_item_title">描述</div>
          <div class="detail_item_value">{{ chooseData.description }}</div>
        </div>
        <div class="detail_item" v-if="chooseData.nameother">
          <div class="detail_item_title">别名</div>
          <div class="detail_item_value">{{ chooseData.nameother }}</div>
        </div>
        <div class="detail_item" v-if="(chooseData.path || chooseData.photolist) &&
          !chooseData.path.includes('.pdf')
          ">
          <div class="detail_item_title">图片</div>
          <div class="detail_item_value">
            <img style="width: 60%; margin-left: 20%" :src="chooseData.path.replace(
              '/home/tscon/we/mcc/',
              'http://edam.tscon.cn:7777/mcc/'
            )
              " />
          </div>
        </div>
        <div class="detail_item">
          <el-button type="primary" v-if="chooseData.isbook" @click="preViewBook(chooseData)">查看</el-button>

          <el-button type="primary" @click="goDe2(chooseData.label)">图谱扩展</el-button>
          <el-button type="primary" v-if="chooseData.path && chooseData.path.includes('.pdf')"
                     @click="checkPdfFile(chooseData.path)">预览</el-button>
        </div>
      </div>
    </el-drawer>
    <div v-if="isPhone == false">
      <el-dialog title="提示" :visible.sync="dialogVisible" width="50%">
        <div style="width: 100%; text-align: center">
          <h2>中国雅江清洁能源有限公司</h2>
          <input type="text" class="s_ipt" name="wd" id="kw" maxlength="100" autocomplete="off" />
          <!-- @click="searchclick" -->
          <input @click="searchclick"  type="submit" value="点击检索" id="su" class="btn self-btn bg s_btn" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-else-if="isPhone == true">
      <el-dialog title="提示" :visible.sync="dialogVisible" width="90%">
        <div style="width: 100%; text-align: center">
          <h2>中国雅江清洁能源有限公司</h2>
          <input type="text" class="s_ipt" name="wd" style="width: 50%" id="kw" maxlength="100" autocomplete="off" />
          <input @click="searchclick" type="submit" value="点击检索" id="su" class="btn self-btn bg s_btn" />
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-show="iframeShow" class="iframeClass">
      <div style="border: 1px solid">
        <el-button type="info" icon="el-icon-close" size="small" @click="iframeShow = false">取消预览</el-button>
      </div>
      <!-- <iframe :src="fileUrl" frameborder="0" width="100%" height="100%"></iframe> -->
      <iframe :src="'/mcc/earthgo/static/pdfjs/web/viewer.html?file=' +
        fileUrl +
        '&keyword=' +
        askinfo
        " frameborder="0" width="100%" height="100%"></iframe>
    </div>
    <el-dialog title="预览" :visible.sync="dialogVisibleFile" width="70%" :before-close="handleClose">
      <iframe v-if="dialogVisibleFile" :src="fileURL" frameborder="0" style="width: 100%; height: 65vh"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import tupuRight from "./tupu_right.vue";
import userapi from "@/api/user";
import ForceGraph3D from "3d-force-graph";
import {
  CSS2DRenderer,
  CSS2DObject,
} from "three/examples/jsm/renderers/CSS2DRenderer.js";
export default {
  components: {
    Map,
    tupuRight,
    // Echart5,
  },
  data() {
    return {
      Graph: null,
      dialogVisibleFile: false, //pdf查看
      fileURL: "", //pdfurl
      isPhone: false,
      dialogTableVisiblejd: false,
      dialogVisible: false,
      chooseData: {},
      askinfo: "",
      iframeShow: false,
      fileUrl: "",
      dialogTableVisible: false,
      bookTableList: [],
      page: 1,
      pagecount: 0,
      keyword: "",
      node: [],
      source: [],
      tatley: {},
      searchinfo: "",
      graph: undefined,
      gg: null,
      gg2: null,
      graphs: null,
      subTreex: "",
      subTreey: "",
      rollback: [],
      rollbacks: "",
      index: 0,
      nodesx: false,
      roll: "",
      nodeclick: 0,
      clickNodeData: [],
      searchKey: "",

    };
  },

  mounted() {
    // 初始化左边的graph
    this.gothree()
    if (window.innerWidth > 1100) {
      this.isPhone = false;
    } else {
      this.isPhone = true;
      this.Neo4jTreeQuery();
    }

    console.log("isPhone",this.isPhone)
    //ask 万姐
    this.searchinfo =
      this.$route.query.searchinfo == undefined
        ? ""
        : this.$route.query.searchinfo;
    if (this.$route.query.searchinfo != undefined) {
      window.location.hash = "#map";
    }
    this.$nextTick(() => {
      this.searchBook();
    })
    this.dialogTableVisible = false;
    // 获取节点数据
    userapi.getTreeGraph().then((res) => {
      this.dataList = res.data;
    });
  },
  // watch: {
  //   tupudata: {
  //     deep: true,
  //     handler: function (val) {
  //     },
  //   },
  // },
  methods: {
    searchBook() {
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      userapi
        .getRequest("/api/getTupuTree", {
          text: this.searchinfo,
        })
        .then((res) => {
          let node = [
            {
              id: "0",
              label: "知识图谱",
              children: [],
              user: "d3noob",
            },
          ];
          let link = [];
          for (var a = 0; a < res.data.length; a++) {
            node.push({
              id: res.data[a].c_id + "",
              label: res.data[a].c_name,
              user: "d3noob",
              c_desc: res.data[a].c_desc,
            });
            link.push({
              source: 0 + "",
              target: res.data[a].c_id + "",
            });
          }
          if (this.Graph) {
            const currentData = this.Graph.graphData();
            // 更新节点和边的数据
            const updatedData = {
              nodes: [...currentData.nodes, ...node],
              links: [...currentData.links, ...link]
            };
            this.Graph.graphData(updatedData);
            // this.Graph.graph.fitGraphToViewport();
            // this.Graph.d3Force('center', 0.1);
            this.clickNodeData.push(this.Graph.graphData())
          }
        });
      loading.close();
    },
    gothree() {
      let that = this;
      const elem = document.getElementById("mynetwork");
      let width = elem.clientWidth;
      let height = elem.clientHeight;

      let Graph = ForceGraph3D({
        extraRenderers: [new CSS2DRenderer()],
        width: width, // 设置宽度
        height: height, // 设置高度
      })(elem).width(width).height(height);


      Graph.nodeLabel("label")
        .cameraPosition({x: 0, y: 0, z: 100})
        .width(width)
        .height(height)
        .nodeAutoColorBy("c_desc")
        .nodeThreeObject((node) => {
          const nodeEl = document.createElement("div");
          nodeEl.textContent = node.label;
          nodeEl.style.color = "white";
          nodeEl.className = "node-label";
          return new CSS2DObject(nodeEl);
        })
        .linkDirectionalParticleSpeed(0)
        // .cameraPosition(
        //     { x: '50%', y: '-10%', z: 180 }, // new position
        //     { x: '50%', y: '-10%', z: 0 }, // lookAt ({ x, y, z })
        //     500 // ms transition duration
        // )
        .linkVisibility(true)                                                 // 是否显示边
        .linkLabel(r => r.type)
        // 边的标签显示（鼠标滑到边上显示）
        .linkDirectionalArrowLength(3.5)                                      // 边的指向箭头长度
        .linkDirectionalArrowRelPos(1)                                        // 边的标签显示（鼠标滑到边上显示）
        .linkCurvature(0.25)                                                  // 边的透明度
        .linkDirectionalParticles(0)                                          // 边粒子：数量
        .linkDirectionalParticleSpeed(1)                                      // 边粒子：移动速度
        .linkDirectionalParticleWidth(0.3)                                    // 边粒子：大小
        .linkColor(() => 'rgb(170,170,170)')                                    // 边颜色
        .linkAutoColorBy(r => r.type)                                         // 边颜色自动化分
        .linkOpacity(0.5)
        .nodeThreeObjectExtend(true)
        .onEngineStop(() => Graph.zoomToFit(400))
        .onNodeClick((node) => {
          this.clickItem(node)
        });
      this.Graph = Graph
    },
    clickItem(node) {
      if (node.c_desc) {
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        userapi
          .getRequest("/api/getType", {
            type: node.c_desc,
          })
          .then((res) => {
            var backd = res.data.data;
            let nodes = []
            let link = []
            const t1 = new Date().valueOf();
            for (var a = 0; a < backd.length; a++) {
              var idd = node.c_desc + "" + a;
              nodes.push({
                id: idd,
                label: backd[a],
                user: "d3noob",
                text: node.c_desc,
              });
              link.push({
                source: node.id,
                target: idd,
              });
            }
            if (this.Graph) {
              const currentData = this.Graph.graphData();
              // 更新节点和边的数据
              const updatedData = {
                nodes: [...currentData.nodes, ...nodes],
                links: [...currentData.links, ...link]
              };
              this.Graph.graphData(updatedData);
              this.clickNodeData.push(this.Graph.graphData())
              loading.close();
            }
          });
      } else {
        this.dialogTableVisiblejd = true;
        node.bookurl = node.path;
        node.bookkey = node.label;
        if (!node.isbook && node.path) {
          node.photolist = node.path.split(";")[0];
        }
        this.chooseData = node;
      }
    },
    // 图谱扩展
    goDe2(text) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      userapi
        .getRequest("/api/getTupuTreeByData", {
          text: text,
        })
        .then((res) => {
          var links = [];

          for (var a = 0; a < res.data.data.nodes.length; a++) {
            res.data.data.nodes[a].id += "";
            if (res.data.data.nodes[a].labels == "Literature") {
              res.data.data.nodes[a].isbook = true;
            } else {
              res.data.data.nodes[a].isbook = false;
            }
            res.data.data.nodes[a].label = res.data.data.nodes[a].name;
          }
          for (var a = 0; a < res.data.data.edges.length; a++) {
            links.push({
              source: res.data.data.edges[a].from + "",
              target: res.data.data.edges[a].to + "",
            });
          }

          if (this.Graph) {
            const currentData = this.Graph.graphData();
            // 更新节点和边的数据
            const updatedData = {
              nodes: [...currentData.nodes, ...res.data.data.nodes],
              links: [...currentData.links, ...links]
            };
            this.Graph.graphData(updatedData);
            this.clickNodeData.push(this.Graph.graphData())
          }
          this.dialogTableVisiblejd = false
          loading.close();
        });
    },
    // 回退
    goRollback() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.clickNodeData = this.clickNodeData.slice(0, this.clickNodeData.length - 1)
      if (this.clickNodeData.length == 0) {
        this.Graph.graphData({
          nodes: [],
          links: []
        })
        this.searchBook()
      } else {
        this.Graph.graphData(this.clickNodeData[this.clickNodeData.length - 1]);

      }
      loading.close()
    },
    changeNode(data) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      userapi
        .getRequest("/api/getTupuTreeByData", {
          text: data.trim()
        })
        .then((res) => {
          if (res.data.data.nodes.length == 0) {
            loading.close()
            return this.$message({
              message: '未找到相关数据',
              type: 'warning'
            })
          }
          var links = [];
          // 修改前
          let node = []
          for (var a = 0; a < res.data.data.nodes.length; a++) {
            res.data.data.nodes[a].id += "";
            node.push({
              id: res.data.data.nodes[a].id,
              name: res.data.data.nodes[a].name,
              label: res.data.data.nodes[a].name,
            })
            if (res.data.data.nodes[a].labels == "Literature") {
              res.data.data.nodes[a].isbook = true;
            } else {
              res.data.data.nodes[a].isbook = false;
            }
            res.data.data.nodes[a].label = res.data.data.nodes[a].name;
          }
          for (var a = 0; a < res.data.data.edges.length; a++) {
            links.push({
              source: res.data.data.edges[a].from + "",
              target: res.data.data.edges[a].to + "",
            });
          }
          if (this.Graph) {
            const currentData = this.Graph.graphData();
            // 更新节点和边的数据
            const updatedData = {
              nodes: [...currentData.nodes, ...node],
              links: [...currentData.links, ...links]
            };
            this.Graph.graphData(updatedData);
            this.clickNodeData.push(this.Graph.graphData())
          }
          loading.close()
        });
    },
    // 查看pdf文件
    checkPdfFile(data) {
      this.dialogVisible = true
      this.fileURL = KKFILEURL + "/onlinePreview?url=" + encodeURIComponent(Base64.encode(data.replace(
        '/home/tscon/we/mcc/',
        'http://edam.tscon.cn:7777/mcc/'
      )));
    },
    preViewBook(item) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      userapi
        .getRequest("/search/dealBook", {
          keyword: item.bookkey,
          fileurl: item.bookurl,
        })
        .then((res) => {
          loading.close();
          this.fileUrl = res.data.replace(
            "/home/tscon/we/mcc/",
            "http://edam.tscon.cn:7777/mcc/"
          );
          this.iframeShow = true;
          this.dialogTableVisible = false;
        });
    },
    // 关闭标签
    handleClose(done) {
      done();
    },
    //点击检索
    searchclick() {
      /*var search = document.getElementById("kw").value;
      if (search == "") {
        alert("请输入内容");
        return;
      }*/

      if (this.searchKey == "") {
        alert("请输入内容");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      userapi
        .getRequest("/api/getTupuTreeByData", {
          text: this.searchKey,
        })
        .then((res) => {
          var links = [];
          // 修改前
          for (var a = 0; a < res.data.data.nodes.length; a++) {
            res.data.data.nodes[a].id += "";
            if (res.data.data.nodes[a].labels == "Literature") {
              res.data.data.nodes[a].isbook = true;
            } else {
              res.data.data.nodes[a].isbook = false;
            }
            res.data.data.nodes[a].label = res.data.data.nodes[a].name;
          }
          for (var a = 0; a < res.data.data.edges.length; a++) {
            links.push({
              source: res.data.data.edges[a].from + "",
              target: res.data.data.edges[a].to + "",
            });
          }

          if (this.Graph) {
            const currentData = this.Graph.graphData();
            // 更新节点和边的数据
            const updatedData = {
              nodes: [...currentData.nodes, ...res.data.data.nodes],
              links: [...currentData.links, ...links]
            };
            this.Graph.graphData(updatedData);
            this.clickNodeData.push(this.Graph.graphData())
          }
          this.dialogVisible = false;
          loading.close();

        });
    },
    Neo4jTreeQuery() {
      let that = this;
      let nodes = {
        id: "0",
        name: "生态图谱",
        children: [],
      };
      this.dataList.forEach((tree) => {
        nodes.children.push(tree);
      });

      this.tatley = nodes;
      const container = document.getElementById("ecologicalTree");
      const width = container.offsetWidth == 0 ? 500 : container.offsetWidth;
      const height = container.scrollHeight || 900;
      const graph = new G6.TreeGraph({
        container: container,
        width,
        height,
        fitView: true, // 设置自动缩放
        fitCenter: true, //是否撑满
        modes: {
          default: [
            {
              type: "collapse-expand",
              onChange(item, collapsed) {
                const data = item.get("model");
                data.collapsed = collapsed;
                return true;
              },
            },
            "drag-canvas",
            "zoom-canvas",
          ],
        },
        defaultNode: {
          size: 26,
          anchorPoints: [
            [0, 0.5],
            [1, 0.5],
          ],
        },
        defaultEdge: {
          type: "cubic-horizontal",
        },
        series: [
          {
            initialTreeDepth: 1,
          },
        ],
        layout: {
          type: "dendrogram",
          direction: "LR", // H / V / LR / RL / TB / BT
          nodeSep: 30, // 节点之间间距
          rankSep: 100, // 每个层级之间的间距
        },
        depth: 2,
      });
      graphData = graph;
      graph.on("node:click", (e) => {
        if (this.nodeclick === 0) {
          this.nodeclick++;
        } else {
          const nodeItem = e.item; // 获取被点击的节点元素对象
          const loading = that.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          userapi
            .getRequest("/api/getTupuTreeByData", {
              text: nodeItem._cfg.model.label,
            })
            .then((res) => {
              loading.close();
              var links = [];

              for (var a = 0; a < res.data.data.nodes.length; a++) {
                res.data.data.nodes[a].id += "";
                if (res.data.data.nodes[a].labels == "Literature") {
                  res.data.data.nodes[a].isbook = true;
                } else {
                  res.data.data.nodes[a].isbook = false;
                }
                res.data.data.nodes[a].label = res.data.data.nodes[a].name;
              }
              for (var a = 0; a < res.data.data.edges.length; a++) {
                links.push({
                  source: res.data.data.edges[a].from + "",
                  target: res.data.data.edges[a].to + "",
                });
              }
              var data = {
                nodes: res.data.data.nodes,
                links: links,
              };

              if (graph) {
                const currentData = graph.graphData();
                // 更新节点和边的数据
                const updatedData = {
                  nodes: [...currentData.nodes, ...node],
                  links: [...currentData.links, ...link]
                };
                graph.graphData(updatedData);
                this.clickNodeData.push(graph.graphData())
              }
            });
          loading.close()
        }
      });
      graph.node(function (node) {
        return {
          label: node.name,
          labelCfg: {
            position:
              node.children && node.children.length > 0 ? "left" : "right",
            offset: 5,
          },
        };
      });

      // 给对应子树节点id加上一个时间戳,形成独有id
      G6.Util.traverseTree(nodes, (subTree, parent, index) => {
        const timestamp =
          Math.floor(Math.random() * (new Date().getTime() - 0 + 1)) + 0;
        subTree.id = subTree.id + timestamp;
      });
      graph.data(nodes);
      graph.render();
      graph.fitView();
      G6.Util.traverseTree(nodes, (subTree) => {
        if (subTree.depth > 1) {
          //collapsed为true时默认收起
          subTree.collapsed = true;
        }
      });
      const findNode = graph.findAll("node", (nodes) => {
        return nodes.get("model").x;
      });
      graph.emit("node:click", {
        item: findNode[1], // 被点击的节点
      });
      graph.data(nodes);
      graph.render();
      graph.fitView();
      if (typeof window !== "undefined")
        window.onresize = () => {
          if (!graph || graph.get("destroyed")) return;
          if (!container || !container.scrollWidth || !container.scrollHeight)
            return;
          graph.changeSize(container.scrollWidth, container.scrollHeight);
        };
    },
  },
};
</script>

<style scoped>
.phonr_item {
  display: flex;
  flex-direction: column;
}

#kw {
  box-sizing: content-box;
  width: 80%;
  height: 16px;
  margin: 0;
  padding: 12px 16px;
  overflow: hidden;
  color: #222;
  font-size: 16px;
  vertical-align: top;
  background: #fff;
  border: 2px solid #c4c7ce;
  border-radius: 10px 0 0 10px;
  outline: 0;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
}

#su {
  width: 108px;
  height: 44px;
  padding: 0;
  color: #fff;
  font-weight: 400;
  font-size: 17px;
  line-height: 45px;
  line-height: 44px\9;
  background: 0 0;
  background-color: #4e6ef2;
  border: none;
  border-radius: 0 10px 10px 0;
  outline: 0;
  box-shadow: none;
  cursor: pointer;
}

.tupu {
  width: 100%;
  height: 100% !important;
  padding: 0 !important;
  overflow: hidden;
  position: relative;
}

#mynetwork {
  width: 100%;
  height: 100% !important;
}

.detail_item {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  padding: 20px;
  text-align: left;
}

.detail_item_title {
  width: 80px !important;
  font-size: 16px;
}

.detail_item_value {
  width: 80% !important;
}

.searchClass {
  position: absolute;
  top: 4%;
  right: 2%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 25%;

}

>>> .searchClass {
  .el-input {
    width: 200px;
  }
  .el-input .el-input__inner{
    border: 1px solid #FFFFFF;
    color: #FFFFFF;
    background-color: transparent;
  }

  .el-input .el-input__inner::placeholder {
    color: #FFFFFF;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/Tupu/comp/LeftTopTuPu.vue